import { jsx as _jsx } from "react/jsx-runtime";
import { EApplicantType } from '@if/core/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDefaultConfig, useScript } from './vouched-hooks';
const id = 'vouched-container';
const VouchedComponent = ({ session, creditApplication, logoUrl, callbacks, applicantType = EApplicantType.Applicant, }) => {
    useTranslation(); // ensures translation context loaded
    const scriptLoaded = useScript('https://static.vouched.id/plugin/releases/latest/index.js');
    const { config } = useDefaultConfig(creditApplication, session, logoUrl, callbacks, applicantType);
    useEffect(() => {
        if (scriptLoaded && window.Vouched) {
            const vouched = window.Vouched({ ...config });
            vouched.mount(`#${id}`);
            return () => {
                vouched.unmount(`#${id}`);
            };
        }
    }, [scriptLoaded, config]);
    return (_jsx("div", { id: id, style: {
            height: '100%',
        } }));
};
export default VouchedComponent;
